import { FormGroup, ValidatorFn, ValidationErrors } from "@angular/forms";

// see https://stackoverflow.com/a/45514884
export const atLeastOne = (validator: ValidatorFn) => (
    group: FormGroup,
): ValidationErrors | null => {
    const hasAtLeastOne = group && group.controls && Object.keys(group.controls)
        .some(k => !validator(group.controls[k]));

    return hasAtLeastOne ? null : {
        atLeastOne: true,
    };
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/core/at-least-one-validator.ts